<template>
  <div class="bg-picker border-t border-default">
    <div v-if="country=='FI'" class="bg-picker md:border-t border-default">
      <div class="container xxl:px-24">
        <div class="flex flex-wrap pt-32 justify-center">
          <img class="w-64 xl:w-80 h-auto mr-32 mb-20" style="align-self: center;" alt="Nordea" src="~/assets/images/nordea.png">
          <img class="w-32 xl:w-44 h-auto mr-32 mb-20" style="align-self: center;" alt="OP" src="~/assets/images/opbank.png">
          <img class="w-64 xl:w-80 h-auto mr-32 mb-20" style="align-self: center;" alt="S-pankki" src="~/assets/images/spankki.png">
          <img class="w-64 xl:w-80 h-auto mr-32 mb-20" style="align-self: center;" alt="Danske Bank" src="~/assets/images/danskebank.png">
          <img class="w-44 xl:w-64 h-auto mr-32 mb-20" style="align-self: center;" alt="Saastopankki" src="~/assets/images/saastopankki.png">
          <img class="w-64 xl:w-80 h-auto mr-32 mb-20" style="align-self: center;" alt="OmaSp" src="~/assets/images/omasp.png">
          <img class="w-64 xl:w-80 h-auto mr-32 mb-20" style="align-self: center;" alt="POP Pankki" src="~/assets/images/poppankki.png">
          <img class="w-64 xl:w-80 h-auto mr-32 mb-20" style="align-self: center;" alt="Aktia" src="~/assets/images/aktia.png">
          <img class="w-64 xl:w-96 h-auto mr-32 mb-20" style="align-self: center;" alt="Alandsbanken" src="~/assets/images/alandsbanken.png">
          <img class="w-64 xl:w-96 h-auto mr-32 mb-20" style="align-self: center;" alt="Handelsbanken" src="~/assets/images/handelsbanken.png">
          <img class="w-64 xl:w-80 h-auto mb-20" style="align-self: center;" alt="Klarna" src="~/assets/images/klarna.png">
        </div>
      </div>
    </div>
    <div
      class=" md:pt-70 pt-36 pb-20 flex justify-between flex-col md:flex-row container xxl:px-24 "
    >
      <div
        class=" md:max-w-410 max-w-full flex-1 md:pb-0 pb-48 md:border-b-0 border-b border-default "
      >
        <div class="text-base-medium text-black-full mb-12">
          {{ config.newsletter?.newsletter_title }}
        </div>
        <div class="text-small text-black-75 mb-12">
          {{ config.newsletter?.newsletter_content }}
        </div>

        <TextInput
          class="text-small"
          :placeholder="$lang('footer', 'newsletter_signup_placeholder')"
          :error="hasEmailError"
          :icon="'arrow-right'"
          :icon-style="'fal'"
          :border-color="'#979D95'"
          :icon-color="iconColor"
          type="email"
          autocomplete="email"
          @submit-input="setEmail"
          @enter-submit="applyNewsletterSignup"
        >
          <div class="absolute top-24 right-0">
            <transition name="fade" mode="out-in">
              <div :key="emailStatus">
                <fa
                  v-if="emailStatus === 'ERROR'"
                  class="text-warning"
                  :icon="['fal', 'times']"
                />
                <fa
                  v-else-if="emailStatus === 'LOADING'"
                  :icon="['fal', 'spinner']"
                  :spin="true"
                />
                <fa
                  v-else-if="emailStatus === 'SUCCESS'"
                  class="text-success"
                  :icon="['fal', 'check']"
                />
                <fa
                  v-else
                  :icon="['fal', 'arrow-right']"
                  class="cursor-pointer select-none"
                  @click="applyNewsletterSignup"
                />
              </div>
            </transition>
          </div>
        </TextInput>
        <transition name="fold">
          <div
            v-if="emailResponse"
            class="mt-8 text-xxs max-h-24 wp-content"
            :class="{
              'text-warning': hasEmailError,
            }"
          >
            <span v-html="emailResponse" />
          </div>
        </transition>
      </div>
      <div
        v-for="link in navigation"
        :key="link.title"
        class="md:border-b-0 border-b border-default"
      >
        <div
          class="
            text-base-medium text-black-full
            flex
            justify-between
            md:p-0
            py-24
            cursor-pointer
            select-none
            mb-0
            md:mb-12
          "
          @click="openRow(link.title)"
        >
          <nuxt-link v-if="!isExternalLink(link)" :to="link.url">
            {{ link.title }}
          </nuxt-link>
          <component
            :is="
              link.children.length > 0 || link.url === '#' ? 'div' : 'nuxt-link'
            "
            v-else
            :href="link.url"
            :target="link.external ? '_blank' : ''"
          >
            {{ link.title }}
          </component>
          <div v-if="uiStore.isMobile">
            <fa v-if="openMenuLink === link.title" :icon="['fal', 'minus-circle']" />
            <fa v-else :icon="['fal', 'plus-circle']" />
          </div>
        </div>
        <transition name="fold">
          <div v-if="!uiStore.isMobile || openMenuLink === link.title" class="max-h-300">
            <div
              v-for="subLink in link.children"
              :key="subLink.title"
              class="column-link"
            >
              <nuxt-link v-if="!isExternalLink(subLink)" :to="subLink.url">
                {{ subLink.title }}
              </nuxt-link>
              <a
                v-else
                :href="subLink.url"
                :target="subLink.external ? '_blank' : ''"
              >
                {{ subLink.title }}
              </a>
            </div>
          </div>
        </transition>
      </div>
      <div v-if="socialMediaAccounts.length > 0" class="md:pr-56 pr-0 md:border-b-0 border-b border-default md:mb-32">
        <div
          class="
            text-base-medium text-black-full
            flex
            justify-between
            md:p-0
            py-24
            select-none
            mb-0
            md:mb-12
          "
          @click="openRow($lang('footer', 'social_media'))"
        >
          {{ $lang('footer', 'social_media') }}
          <div v-if="uiStore.isMobile">
            <fa v-if="openMenuLink === $lang('footer', 'social_media')" :icon="['fal', 'minus-circle']" />
            <fa v-else :icon="['fal', 'plus-circle']" />
          </div>
        </div>
        <transition name="fold">
          <div v-if="!uiStore.isMobile || openMenuLink === $lang('footer', 'social_media')" class="max-h-300">
            <div
              v-for="account in socialMediaAccounts"
              :key="account.platform"
              class="column-link"
            >
              <a
                :href="account.url"
                target="_blank"
                class="flex items-center capitalize"
              >
                <span
                  class=" p-8 rounded-full bg-blue-25 mr-8 w-24 h-24 flex items-center justify-center"
                >
                  <fa :icon="['fab', account.icon]" />
                </span>

                {{ account.platform }}
              </a>
            </div>
          </div>
        </transition>
      </div>
      <div v-if="markets.length > 0" class="md:pr-56 pr-0 md:border-b-0 border-b border-default md:mb-32">
        <div
          class="
            text-base-medium text-black-full
            flex
            justify-between
            md:p-0
            py-24
            select-none
            mb-0
            md:mb-12
          "
          @click="openRow('Välj land')"
        >
          {{ $lang('footer', 'choose_country') }}
          <div v-if="uiStore.isMobile">
            <fa v-if="openMenuLink === 'Välj land'" :icon="['fal', 'minus-circle']" />
            <fa v-else :icon="['fal', 'plus-circle']" />
          </div>
        </div>
        <transition name="fold">
          <div v-if="!uiStore.isMobile || openMenuLink === 'Välj land'" class="max-h-300">
            <div
              v-for="market in markets"
              :key="market.name"
              class="column-link"
            >
              <a :href="market.url" class="flex items-center capitalize">
                <img
                  v-if="market.flag_url"
                  :src="market.flag_url"
                  class="h-16 w-16 mr-6"
                  alt="flag icon" 
                >
                {{ market.name }}
              </a>
            </div>
          </div>
        </transition>
      </div>
    </div>
    <div class="bg-picker md:border-t border-default">
      <div class="container xxl:px-24">
        <div class="flex pb-48 pt-32 flex-wrap items-center">
          <nuxt-link :to="homeUrl" class="w-full md:w-auto md:pr-24 flex mb-20 md:mb-0">
            <img
              src="~/assets/images/footer-logo.png"
              class="h-40 w-auto"
              alt="Ullmax-logga"
            >
          </nuxt-link>
          <div class="w-full md:w-10/12 text-small text-black-75" v-html="footerText" />
        </div>
      </div>
    </div>
    <div class="bg-blue-full">
      <div
        class="
          md:py-32
          py-24
          flex
          justify-between
          md:flex-row
          flex-col
          items-center
          container
          xxl:px-24
        "
      >
        <div class="text-white md:mb-0 mb-16 mb:text-sm text-xs text-center">
          Copyright © {{ new Date().getFullYear() }}, Ullmax.
        </div>
        <div class="flex">
          <img
            src="/images/logo_black@2x.png"
            alt="Klarnalogga"
            class="md:max-h-16 max-h-12 md:ml-16 h-auto w-auto"
            height="16"
            width="80"
          >
          <img
            src="/images/g4158@2x.png"
            alt="VISA-logga"
            class="md:max-h-16 max-h-12 ml-16 h-auto w-auto"
            height="16"
            width="80"
          >
          <img
            src="/images/Mastercard-logo@2x.png"
            alt="Mastercard-logga"
            class="md:max-h-16 max-h-12 ml-16 h-auto w-auto"
            height="16"
            width="80"
          >
          <img
            src="/images/PostNord@2x.png"
            alt="Postnordlogga"
            class="md:max-h-16 max-h-12 ml-16 h-auto w-auto"
            height="16"
            width="80"
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { Market } from '~/constants/types/market';

import { useConfigStore } from '~/store/config';
import type { NavigationType } from '~/constants/types/navigation';
import { useUiStore } from '~/store/ui';
import TextInput from '~/components/forms/TextInput.vue';
import { pushToDataLayer } from '~/composables/useTracking';
const config = useConfigStore();
const uiStore = useUiStore();
const { centraPost } = useApiFetch();
const { $lang } = useNuxtApp();

const email = ref( '');
const hasEmailError = ref( false);
const emailResponse = ref('');
const emailStatus = ref('INIT');
const openMenuLink = ref('');
const hasValidEmail = ref( false);

const navigation = computed<NavigationType[]>(()=> {
  return config.navigation.footer_navigation;
});

const iconColor = computed<string>(()=> {
  return hasValidEmail.value ? '#283b48' : '#dce1e5';
});

const socialMediaAccounts = computed<{
  icon: string;
  url: string | undefined;
  platform: string;
}[]>(()=> {
  const socialMediaAccounts = config.social_accounts.map((accountRow) => {
    const platform = Object.keys(accountRow)[0];
    const name = Object.values(accountRow)[0];
    let icon = '';
    switch (platform) {
      case 'facebook': {
        icon = 'facebook-square';
        break;
      }
      case 'youtube': {
        icon = 'youtube';
        break;
      }
      case 'twitter': {
        icon = 'twitter';
        break;
      }
      case 'instagram': {
        icon = 'instagram';
        break;
      }
    }
    return {
      icon,
      url: name ? `https://www.${platform}.com/${name}` : undefined,
      platform,
    };
  });
  return socialMediaAccounts.filter((account) => account.url);
});

const footerText = computed<string>(()=> {
  return config.footer_text || '';
});

const markets = computed<Market[]>(()=> {

  return config.markets || [];
});

const homeUrl = computed<string>(()=> {
  return config.home_url;
});

const country = computed<string>(()=> {
  return config.market.country || '';
});

const isExternalLink = (link: any) => {
  return (
    !link.url?.startsWith('/') &&
    !link.url?.includes(process.env.FRONTEND_URL)
  );
};

const applyNewsletterSignup = async() => {
  if (!hasEmailError.value && email.value) {
    emailStatus.value = 'LOADING';
    const res = await centraPost(
      `/newsletter-subscription/${encodeURIComponent(email.value)}`,
      {
        country: config.market.country,
      }
    );
    if (res) {
      pushToDataLayer({
        event: 'email_opt_in',
        location: 'footer',
      });

      emailStatus.value = 'SUCCESS';
      emailResponse.value = config.newsletter?.newsletter_thank_you_text || '';
    } else {
      emailStatus.value = 'ERROR';
      emailResponse.value = $lang('footer', 'error');
      hasEmailError.value = true;
      setTimeout(() => {
        emailStatus.value = 'INIT';
      }, 500);
    }

  } else {
    emailStatus.value = 'LOADING';
    setTimeout(() => {
      emailStatus.value = 'ERROR';
      emailResponse.value = $lang('footer', 'invalid_email');
      hasEmailError.value = true;
    }, 1000);
    setTimeout(() => {
      emailStatus.value = 'INIT';
    }, 2000);
  }
};

const setEmail = (input: string) => {
  if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(input.trim()) || !input) {
    email.value = input;
    emailResponse.value = '';
    hasEmailError.value = false;
    emailStatus.value = 'INIT';
    hasValidEmail.value = input.length > 0;
  } else {
    email.value = input;
    emailResponse.value = 'Ange en korrekt epostadress';
    hasEmailError.value = true;
    hasValidEmail.value = false;
  }
};

const openRow = (title: string) => {
  if (uiStore.isMobile) {
    openMenuLink.value = openMenuLink.value === title ? '' : title;
  }
};

</script>

<style scoped lang="postcss">
.column-title {
  @apply uppercase text-xs;
}

.column-link {
  @apply text-sm mb-12 text-primary;
}

</style>
